import { useEffect } from "react";
import type { AdminCleaner } from "@/mocks/admin";

type Props = {
  cleaner: AdminCleaner | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function ConfirmRemoveModal({ cleaner, onCancel, onConfirm }: Props) {
  useEffect(() => {
    if (!cleaner) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [cleaner, onCancel]);

  if (!cleaner) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-foreground-950/50 backdrop-blur-sm"
        onClick={onCancel}
        aria-hidden="true"
      ></div>
      <div className="relative bg-background-50 rounded-2xl w-full max-w-sm p-6 animate-fade-up">
        <div className="flex items-start gap-3">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 flex-shrink-0">
            <i className="ri-error-warning-line text-lg"></i>
          </span>
          <div className="flex-1">
            <h4 className="font-heading text-lg text-foreground-950">
              Remove {cleaner.name}?
            </h4>
            <p className="text-xs text-foreground-600 mt-1 leading-relaxed">
              This cleaner will be taken off the roster. Existing bookings stay
              assigned but they won't be eligible for new ones.
            </p>
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 mt-5">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-md text-sm font-medium text-foreground-800 hover:bg-background-100 whitespace-nowrap cursor-pointer"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md text-sm font-medium bg-accent-600 hover:bg-accent-700 text-background-50 whitespace-nowrap cursor-pointer"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
}